import { useAuthContext } from "./useAuthContext"

export const useLogout = () => {
    const { dispatch } = useAuthContext()

    const logout = () => {
        //empty localstorage
        localStorage.removeItem('user')

        //dispatch 'LOGOUT'
        dispatch({ type : 'LOGOUT'})
    }

    return { logout }
}